import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log, errorMsg } from 'utils';

export const SCREEN_SCHEDULING_FETCH_DATA_INIT = createAction(
  'SCREEN_SCHEDULING_FETCH_DATA_INIT'
);
export const SCREEN_SCHEDULING_FETCH_DATA_SUCCESS = createAction(
  'SCREEN_SCHEDULING_FETCH_DATA_SUCCESS'
);
export const SCREEN_SCHEDULING_FETCH_DATA_FAIL = createAction(
  'SCREEN_SCHEDULING_FETCH_DATA_FAIL'
);

export const SCREEN_SCHEDULING_DELETE_SCHEDULING_INIT = createAction(
  'SCREEN_SCHEDULING_DELETE_SCHEDULING_INIT'
);
export const SCREEN_SCHEDULING_DELETE_SCHEDULING_SUCCESS = createAction(
  'SCREEN_SCHEDULING_DELETE_SCHEDULING_SUCCESS'
);
export const SCREEN_SCHEDULING_DELETE_SCHEDULING_FAIL = createAction(
  'SCREEN_SCHEDULING_DELETE_SCHEDULING_FAIL'
);

export const SCREEN_SCHEDULING_CLEAR_DATA = createAction(
  'SCREEN_SCHEDULING_CLEAR_DATA'
);

export const SCREEN_SCHEDULING_CREATE_SCHEDULING_INIT = createAction(
  'SCREEN_SCHEDULING_CREATE_SCHEDULING_INIT'
);
export const SCREEN_SCHEDULING_CREATE_SCHEDULING_SUCCESS = createAction(
  'SCREEN_SCHEDULING_CREATE_SCHEDULING_SUCCESS'
);
export const SCREEN_SCHEDULING_CREATE_SCHEDULING_FAIL = createAction(
  'SCREEN_SCHEDULING_CREATE_SCHEDULING_FAIL'
);

export const SCREEN_SCHEDULING_MODIFY_SCHEDULING_INIT = createAction(
  'SCREEN_SCHEDULING_MODIFY_SCHEDULING_INIT'
);
export const SCREEN_SCHEDULING_MODIFY_SCHEDULING_SUCCESS = createAction(
  'SCREEN_SCHEDULING_MODIFY_SCHEDULING_SUCCESS'
);
export const SCREEN_SCHEDULING_MODIFY_SCHEDULING_FAIL = createAction(
  'SCREEN_SCHEDULING_MODIFY_SCHEDULING_FAIL'
);

export const SCREEN_SCHEDULING_CLEAN_UP = createAction(
  'SCREEN_SCHEDULING_CLEAN_UP'
);

export const SCREEN_SCHEDULING_CLEAR_DATA_LOGOUT = createAction(
  'SCREEN_SCHEDULING_CLEAR_DATA_LOGOUT'
);

export const SET_SCREEN_SCHEDULING = createAction('SET_SCREEN_SCHEDULING');

export const fetchScreenScheduling = ({ schedulingId, siteId, screenId }) => {
  return async (dispatch, getState) => {
    dispatch(SCREEN_SCHEDULING_FETCH_DATA_INIT());
    if (schedulingId) {
      let schedulingData;
      try {
        schedulingData = await Axios.get(`${url}/screen-scheduling/get`, {
          params: {
            id: schedulingId,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(SCREEN_SCHEDULING_FETCH_DATA_FAIL({ error }));
      }
      const scheduling = { ...schedulingData.data.data, id: schedulingId };
      return dispatch(
        SCREEN_SCHEDULING_FETCH_DATA_SUCCESS({
          list: getState().screenScheduling.list,
          scheduling,
        })
      );
    }

    if (siteId) {
      let schedules;
      try {
        const params = { siteId };
        if (screenId) {
          params.screenId = screenId;
        }

        schedules = await Axios.get(`${url}/screen-scheduling`, {
          params,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(SCREEN_SCHEDULING_FETCH_DATA_FAIL({ error }));
      }
      return dispatch(
        SCREEN_SCHEDULING_FETCH_DATA_SUCCESS({
          list: schedules.data.data,
          scheduling: getState().screenScheduling.scheduling,
        })
      );
    }
  };
};

export const deleteScreenScheduling = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(SCREEN_SCHEDULING_DELETE_SCHEDULING_INIT());

    try {
      await Axios.delete(`${url}/screen-scheduling/delete`, {
        params: {
          id,
          siteId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCREEN_SCHEDULING_DELETE_SCHEDULING_FAIL({
          error: errorMessage,
        })
      );
    }

    toastr.success('', 'The screen scheduling was deleted.');
    cb();
    return dispatch(SCREEN_SCHEDULING_DELETE_SCHEDULING_SUCCESS({ id }));
  };
};

export const clearScreenSchedulingData = () => {
  return (dispatch) => {
    dispatch(SCREEN_SCHEDULING_CLEAR_DATA());
  };
};

export const clearScreenSchedulingDataLogout = () => {
  return (dispatch) => {
    dispatch(SCREEN_SCHEDULING_CLEAR_DATA_LOGOUT());
  };
};

export const createScreenScheduling = (
  { name, description, days, start, end, dates, siteId, screenId, activeConfigIndices },
  setIsModalShow
) => {
  return async (dispatch) => {
    dispatch(SCREEN_SCHEDULING_CREATE_SCHEDULING_INIT());
    let createSchedule;
    const scheduling = {
      name,
      description,
      start,
      end,
      days: JSON.stringify(days),
      dates: JSON.stringify(dates),
      siteId,
      screenId,
      activeConfigIndices: JSON.stringify(activeConfigIndices),
    };

    try {
      createSchedule = await Axios.post(`${url}/screen-scheduling/create`, scheduling, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      log(createSchedule, '<<< created screen scheduling');
    } catch (error) {
      log(error.response, '<<< ERROR CREATE SCREEN SCHEDULING');
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCREEN_SCHEDULING_CREATE_SCHEDULING_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Screen scheduling created successfully');
    setIsModalShow(false);
    dispatch(fetchScreenScheduling({ siteId, screenId }));
    return dispatch(
      SCREEN_SCHEDULING_CREATE_SCHEDULING_SUCCESS({
        scheduling: createSchedule.data.data,
      })
    );
  };
};

export const modifyScreenScheduling = (
  { id, name, description, siteId, screenId, start, end, days, dates, activeConfigIndices },
  setIsModalShow
) => {
  return async (dispatch) => {
    dispatch(SCREEN_SCHEDULING_MODIFY_SCHEDULING_INIT());

    const schedulingData = {
      id,
      name,
      start,
      end,
      description,
      siteId,
      screenId,
      days: JSON.stringify(days),
      dates: JSON.stringify(dates),
      activeConfigIndices: JSON.stringify(activeConfigIndices),
    };

    try {
      await Axios.post(`${url}/screen-scheduling/edit`, schedulingData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        SCREEN_SCHEDULING_MODIFY_SCHEDULING_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Screen scheduling updated successfully');
    setIsModalShow(false);

    dispatch(fetchScreenScheduling({ siteId, screenId }));
    return dispatch(
      SCREEN_SCHEDULING_MODIFY_SCHEDULING_SUCCESS({
        screenScheduling: schedulingData,
        id,
      })
    );
  };
};

export const screenSchedulingCleanUp = () => (dispatch) =>
  dispatch(SCREEN_SCHEDULING_CLEAN_UP());

export const setScreenScheduling = (data) => {
  return (dispatch) => {
    dispatch(
      SET_SCREEN_SCHEDULING({
        data,
      })
    );
  };
};
